import React, { useState, useEffect } from "react";

const PersonalInfoLeftCard = ({ formData, updateToggle, active, onNavigate }) => {
  const [localFormData, setLocalFormData] = useState({});

  // Initialize local state with formData on mount or when updateToggle changes
  useEffect(() => {
    setLocalFormData(formData);
  }, [formData]);

  return (
    <div className="p-6 bg-white rounded shadow-lg w-1/4">
      <h2 className="text-lg font-bold text-gray-700">Personal Info</h2>

      <div className="mt-6 flex items-center">
        <img
          src={localFormData.profileURL || "/Assets/default_user.png"}
          alt="User Profile"
          className="w-16 h-16 rounded-full object-cover"
        />

        <div className="ml-4">
          <h6 className="text-gray-500 font-bold text-lg flex items-center">
            {localFormData.firstName} {localFormData.lastName}
          </h6>
          <h6 className="text-gray-500 text-sm flex items-center">
            {localFormData.cnic}
          </h6>
        </div>
      </div>

      <div className="mt-6">
        <h6 className="text-blue-600 font-semibold">Email:</h6>
        <span className="text-gray-500 text-sm">
          {localFormData.email || "No email registered yet."}
        </span>

        <h6 className="text-blue-600 font-semibold mt-4">Phone:</h6>
        <span className="text-gray-500 text-sm">
          {localFormData.cellPhone || "No phone number registered yet."}
        </span>

        <h6 className="text-blue-600 font-semibold mt-4">Location:</h6>
        <span className="text-gray-500 text-sm">
          {localFormData.addressCity || "City"}, {localFormData.countryOfBirth || "Country"}
        </span>
      </div>

      <div className="mt-6 space-y-3">
        {/* Personal Information */}
        <button
          type="button"
          className={`${
            active === "personal-information" || active === "" ? "text-blue-700 bg-blue-100" : ""
          } flex items-center justify-between w-full p-3 border border-gray-100 rounded shadow-sm text-gray-700`}
          onClick={() => onNavigate("personal-information")}
        >
          <div className="flex items-center">
            <i
              className={`${
                active === "personal-information" && "text-blue-700"
              } fas fa-user-circle text-gray-700 mr-3`}
            ></i>
            <span>Personal Information</span>
          </div>
          {active === "personal-information" && (
            <i className="fas fa-chevron-right text-blue-700"></i>
          )}
        </button>

        {/* Address Information */}
        <button
          type="button"
          className={`${
            active === "address-information" && "text-blue-700 bg-blue-100"
          } flex items-center justify-between w-full p-3 border border-gray-100 rounded shadow-sm text-gray-700`}
          onClick={() => onNavigate("address-information")}
        >
          <div className="flex items-center">
            <i className="fas fa-map-marker-alt text-gray-700 mr-3"></i>
            <span>Address Information</span>
          </div>
          {active === "address-information" && (
            <i className="fas fa-chevron-right text-blue-700"></i>
          )}
        </button>

        {/* Education Details */}
        <button
          type="button"
          className={`${
            active === "education-details" && "text-blue-700 bg-blue-100"
          } flex items-center justify-between w-full p-3 border border-gray-100 rounded shadow-sm text-gray-700`}
          onClick={() => onNavigate("education-details")}
        >
          <div className="flex items-center">
            <i className="fas fa-graduation-cap text-gray-700 mr-3"></i>
            <span>Education Details</span>
          </div>
          {active === "education-details" && (
            <i className="fas fa-chevron-right text-blue-700"></i>
          )}
        </button>

        {/* Documents */}
        <button
          type="button"
          className={`${
            active === "documents" && "text-blue-700 bg-blue-100"
          } flex items-center justify-between w-full p-3 border border-gray-100 rounded shadow-sm text-gray-700`}
          onClick={() => onNavigate("documents")}
        >
          <div className="flex items-center">
            <i className="fas fa-file-upload text-gray-700 mr-3"></i>
            <span>Documents</span>
          </div>
          {active === "documents" && (
            <i className="fas fa-chevron-right text-blue-700"></i>
          )}
        </button>

        {/* Change Password */}
        <button
          type="button"
          className={`${
            active === "change-password" && "text-blue-700 bg-blue-100"
          } flex items-center justify-between w-full p-3 border border-gray-100 rounded shadow-sm text-gray-700`}
          onClick={() => onNavigate("change-password")}
        >
          <div className="flex items-center">
            <i className="fas fa-key text-gray-700 mr-3"></i>
            <span>Change Password</span>
          </div>
          {active === "change-password" && (
            <i className="fas fa-chevron-right text-blue-700"></i>
          )}
        </button>

        {/* Change Email */}
        <button
          type="button"
          className={`${
            active === "change-email" && "text-blue-700 bg-blue-100"
          } flex items-center justify-between w-full p-3 border border-gray-100 rounded shadow-sm text-gray-700`}
          onClick={() => onNavigate("change-email")}
        >
          <div className="flex items-center">
            <i className="fas fa-envelope text-gray-700 mr-3"></i>
            <span>Change Email</span>
          </div>
          {active === "change-email" && (
            <i className="fas fa-chevron-right text-blue-700"></i>
          )}
        </button>

        {/* Change Mobile Number */}
        <button
          type="button"
          className={`${
            active === "change-mobile-number" && "text-blue-700 bg-blue-100"
          } flex items-center justify-between w-full p-3 border border-gray-100 rounded shadow-sm text-gray-700`}
          onClick={() => onNavigate("change-mobile-number")}
        >
          <div className="flex items-center">
            <i className="fas fa-mobile-alt text-gray-700 mr-3"></i>
            <span>Change Mobile Number</span>
          </div>
          {active === "change-mobile-number" && (
            <i className="fas fa-chevron-right text-blue-700"></i>
          )}
        </button>
      </div>
    </div>
  );
};

export default PersonalInfoLeftCard;
